<template>
<div class="flash-messages">
	<flash-messages-item v-for="flashMessage in flashMessages"
	                     :message="flashMessage.message"
	                     :key="flashMessage.id"
	                     :type="flashMessage.type">
	</flash-messages-item>
</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import FlashMessagesItem from '@/components/elements/FlashMessages/FlashMessagesItem';
const { mapActions, mapGetters } = createNamespacedHelpers('flashMessages');

export default {
	name: 'flash-messages-list',
	components: {
		FlashMessagesItem
	},
	data: () => ({}),
	computed: {
		...mapGetters([
			'flashMessages'
		])
	}
}
</script>
<style lang="scss" scoped>
.flash-messages {
    position: fixed;
    z-index: 100;
    top: 20px;
    left: 70%;
    right: 10%;
}
</style>



// WEBPACK FOOTER //
// FlashMessagesList.vue?f65c177c